import styled from "styled-components";
import { MEDIA_QUERIES } from "../../../../../../constants/mediaQuery";

export const Container = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  min-height: 400px;
`;

export const BackContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex: 1 1 0;
  justify-content: center;
  align-items: center;
  border: none;
  z-index: 2;
  overflow-y: auto;
`;

export const ContentContainer = styled.div`
  overscroll-behavior: contain;
  background-color: #FFF;
  width: 80%;
  height: 90%;
  z-index: 10;
  padding: 1rem;
  max-width: 1920px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0.5rem;

  &:hover {
    cursor: pointer;
    filter: brightness(0.95);
  }
`;

export const SignaturesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  overflow-y: auto;
  height: 100%;
  padding: 0.5rem 0.75rem;

  ${MEDIA_QUERIES.TABLET_LANDSCAPE} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  ${MEDIA_QUERIES.DESKTOP} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  ${MEDIA_QUERIES.BIG_DESKTOP} {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
`;

export const SignatureContainer = styled.div`
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: ${props => props?.isSelected ? '1.5px solid #FF7417' : '1px solid rgba(0, 0, 0, 0.5)'};
  border-radius: 0.5rem;
  padding: 1rem;
  aspect-ratio: 1;
  position: relative;
`;

export const SignatureCheckbox = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-50%, 50%);
  height: 1rem;
  width: 1rem;

  &:hover {
    cursor: pointer;
  }
`;

export const SignatureImage = styled.img`
  height: ${props => props?.config?.extraHeight ? `calc(2em + ${props?.config?.extraHeight}px)` : '2em'};
  padding: 0 0.5rem;
  margin-top: ${props => `${props?.config?.top || 0}px`};
  margin-left: ${props => `${props?.config?.left || 0}px`};
  margin-bottom: ${props => `${props?.config?.bottom || 0}px`};
  margin-right: ${props => `${props?.config?.right || 0}px`};
`;

export const SignatureTextContainer = styled.div`
  padding: 0;
  margin: 0;
  text-align: center;
  width: 100%;
`;

export const SignatureName = styled.p`
  font-size: 0.8em;
  font-weight: 700;
  border-top-width: 0.05rem;
  border-top-style: solid;
  border-top-color: #000; 
  padding: 0.5rem 0.5rem 0 0.5rem;
  margin: 0;
`;

export const SignatureSubtitle = styled.p`
  font-size: 0.6em;
  font-weight: 700;
  margin-top: 0.1rem;
  padding: 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 1rem;
`;

export const MainButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #FF7417;
  color: #FFF;
  font-size: 1rem;
  font-weight: 500;
  border: none;
  border-radius: 0.25rem;
  opacity: ${props => props?.disabled ? 0.5 : 1};

  &:hover {
    cursor: pointer;
    filter: brightness(0.95);
  }
`;

export const FullLoaderContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const FullLoader = styled.div`
  width: 48px;
  height: 48px;
  border: 5px solid #FF7417;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
`;